(function () {
  const config = window.SaleCampaign;
  if (!config) return;

  const parseTime = (value) => {
    if (!value) return 0;
    const parsed = Date.parse(String(value).split(" ").join("T"));
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const startTime = config.start ? parseTime(config.start) : 0;
  const endTime = config.end ? parseTime(config.end) : 0;

  const isActive = () => {
    const now = Date.now();
    const afterStart = !config.start || (startTime > 0 && now >= startTime);
    const beforeEnd = !config.end || (endTime > 0 && now < endTime);
    return config.enabled !== false && afterStart && beforeEnd;
  };

  config.isSlashedPriceActive = () => isActive() && config.showSlashedPrices !== false;

  const getMoneyFormat = () => {
    if (window.MinimogSettings?.money_format) {
      return window.MinimogSettings.money_format;
    }
    return "$" + "{{amount}}";
  };

  const formatPrice = (cents) => {
    if (typeof formatMoney === "function") {
      return formatMoney(cents, getMoneyFormat());
    }
    return (cents / 100).toFixed(2);
  };

  const toggleElements = (selector, show) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (show) {
        element.classList.remove("m:hidden");
        element.removeAttribute("hidden");
      } else {
        element.classList.add("m:hidden");
        element.setAttribute("hidden", "hidden");
      }
    });
  };

  const applyCampaignPrice = (priceEl) => {
    const salePrice = parseInt(priceEl.dataset.salePrice, 10);
    const compareAtPrice = parseInt(priceEl.dataset.saleCompareAt, 10);
    if (!salePrice || !compareAtPrice || compareAtPrice <= salePrice) return;

    const saleItem = priceEl.querySelector(".m-price-item--sale");
    const compareItem = priceEl.querySelector(".m-price__sale s.m-price-item--regular");
    const regularItem = priceEl.querySelector(".m-price__regular .m-price-item--regular");

    if (!saleItem) return;

    if (!priceEl.dataset.saleApplied) {
      priceEl.dataset.saleApplied = "true";
      priceEl.dataset.saleSaleHtml = saleItem.innerHTML;
      if (compareItem) {
        priceEl.dataset.saleCompareHtml = compareItem.innerHTML;
      }
      if (regularItem) {
        priceEl.dataset.saleRegularHtml = regularItem.innerHTML;
      }
    }

    saleItem.innerHTML = formatPrice(salePrice);
    if (compareItem) {
      compareItem.innerHTML = formatPrice(compareAtPrice);
    }

    const percent = Math.round(((compareAtPrice - salePrice) / compareAtPrice) * 100);
    const discountLabel = priceEl.querySelector("[data-sale-discount-label]");
    if (discountLabel && percent > 0 && config.showDiscountBadges !== false) {
      discountLabel.textContent = `${percent}% OFF`;
      discountLabel.hidden = false;
    } else if (discountLabel) {
      discountLabel.textContent = "";
      discountLabel.hidden = true;
    }

    priceEl.classList.add("m-price--on-sale", "m-price--sale-campaign");
  };

  const revertCampaignPrice = (priceEl) => {
    if (!priceEl.classList.contains("m-price--sale-campaign")) return;

    const salePrice = parseInt(priceEl.dataset.salePrice, 10);
    const compareAtPrice = parseInt(priceEl.dataset.saleCompareAt, 10);
    const saleItem = priceEl.querySelector(".m-price-item--sale");
    const compareItem = priceEl.querySelector(".m-price__sale s.m-price-item--regular");
    const regularItem = priceEl.querySelector(".m-price__regular .m-price-item--regular");
    const keepCompareAt =
      Boolean(window.MinimogSettings?.show_compare_at_prices) &&
      salePrice > 0 &&
      compareAtPrice > salePrice;

    if (priceEl.dataset.saleRegularHtml && regularItem) {
      regularItem.innerHTML = priceEl.dataset.saleRegularHtml;
    } else if (regularItem && salePrice) {
      regularItem.innerHTML = formatPrice(salePrice);
    }

    if (priceEl.dataset.saleSaleHtml && saleItem) {
      saleItem.innerHTML = priceEl.dataset.saleSaleHtml;
    }

    if (keepCompareAt && compareItem && compareAtPrice) {
      compareItem.innerHTML = formatPrice(compareAtPrice);
      if (saleItem && salePrice) {
        saleItem.innerHTML = formatPrice(salePrice);
      }
    } else if (priceEl.dataset.saleCompareHtml && compareItem) {
      compareItem.innerHTML = priceEl.dataset.saleCompareHtml;
    }

    const discountLabel = priceEl.querySelector("[data-sale-discount-label]");
    if (discountLabel) {
      if (keepCompareAt && config.showDiscountBadges !== false) {
        const percent = Math.round(((compareAtPrice - salePrice) / compareAtPrice) * 100);
        discountLabel.textContent = percent > 0 ? `${percent}% OFF` : "";
        discountLabel.hidden = percent <= 0;
      } else {
        discountLabel.textContent = "";
        discountLabel.hidden = true;
      }
    }

    if (keepCompareAt) {
      priceEl.classList.add("m-price--on-sale", "m-price--sale-campaign");
    } else {
      priceEl.classList.remove("m-price--on-sale", "m-price--sale-campaign");
    }
    delete priceEl.dataset.saleApplied;
    delete priceEl.dataset.saleSaleHtml;
    delete priceEl.dataset.saleCompareHtml;
    delete priceEl.dataset.saleRegularHtml;
  };

  const DAY_MS = 24 * 60 * 60 * 1000;
  const HOUR_MS = 60 * 60 * 1000;
  const MIN_MS = 60 * 1000;
  const SEC_MS = 1000;

  const setUnit = (container, unit, value) => {
    const unitEl = container.querySelector(`[data-unit="${unit}"]`);
    if (!unitEl) return;
    const padded = String(Math.min(99, Math.max(0, value))).padStart(2, "0");
    const tens = unitEl.querySelector("[data-tens]");
    const ones = unitEl.querySelector("[data-ones]");
    if (tens) tens.textContent = padded[0];
    if (ones) ones.textContent = padded[1];
  };

  const updateInlineCountdown = () => {
    if (!endTime) return;
    const container = document.querySelector("[data-sale-inline-countdown]");
    if (!container) return;

    const diff = Math.max(0, endTime - Date.now());
    const days = Math.floor(diff / DAY_MS);
    const hours = Math.floor((diff % DAY_MS) / HOUR_MS);
    const minutes = Math.floor((diff % HOUR_MS) / MIN_MS);
    const seconds = Math.floor((diff % MIN_MS) / SEC_MS);

    const daysEl = container.querySelector("[data-inline-days]");
    const hoursEl = container.querySelector("[data-inline-hours]");
    const minutesEl = container.querySelector("[data-inline-minutes]");
    const secondsEl = container.querySelector("[data-inline-seconds]");

    if (daysEl) daysEl.textContent = String(days).padStart(2, "0");
    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, "0");
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, "0");
  };

  const updateCountdown = () => {
    if (!endTime) return;
    updateInlineCountdown();

    const containers = document.querySelectorAll("[data-sale-countdown]");
    if (!containers.length) return;

    const diff = Math.max(0, endTime - Date.now());
    const days = Math.floor(diff / DAY_MS);
    const hours = Math.floor((diff % DAY_MS) / HOUR_MS);
    const minutes = Math.floor((diff % HOUR_MS) / MIN_MS);
    const seconds = Math.floor((diff % MIN_MS) / SEC_MS);

    containers.forEach((container) => {
      setUnit(container, "days", days);
      setUnit(container, "hours", hours);
      setUnit(container, "minutes", minutes);
      setUnit(container, "seconds", seconds);
    });
  };

  const activate = () => {
    if (config.showCollectionBanner) {
      toggleElements('[data-sale-campaign].m-sale-collection-banner:not([data-sale-surface="home"]):not([data-sale-surface="pdp"])', true);
      updateCountdown();
    }

    if (config.showHomeTimerBanner) {
      toggleElements('[data-sale-campaign].m-home-timer-banner, [data-sale-campaign][data-sale-surface="home"]', true);
      updateCountdown();
    }

    if (config.showPdpTimerBanner) {
      toggleElements('[data-sale-campaign].m-pdp-timer-banner, [data-sale-campaign][data-sale-surface="pdp"]', true);
      updateCountdown();
    }

    if (config.showSlashedPrices) {
      document.querySelectorAll(".m-price[data-sale-enabled]").forEach(applyCampaignPrice);
    } else {
      document.querySelectorAll(".m-price[data-sale-applied]").forEach(revertCampaignPrice);
    }
  };

  const deactivate = () => {
    toggleElements('[data-sale-campaign].m-sale-collection-banner:not([data-sale-surface="home"]):not([data-sale-surface="pdp"])', false);
    toggleElements('[data-sale-campaign].m-home-timer-banner, [data-sale-campaign][data-sale-surface="home"]', false);
    toggleElements('[data-sale-campaign].m-pdp-timer-banner, [data-sale-campaign][data-sale-surface="pdp"]', false);
    document.querySelectorAll(".m-price[data-sale-applied]").forEach(revertCampaignPrice);
  };

  const tick = () => {
    if (isActive()) {
      activate();
    } else {
      deactivate();
    }
  };

  const init = () => {
    tick();

    if (!window.__saleCampaignInterval) {
      window.__saleCampaignInterval = setInterval(tick, 1000);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
